/**
 * The AI video ad generator's URL and its name in each language, for the
 * one-link footers that point at it: the homepage footer (LandingV2), the
 * footer of the pages in the homepage design (CreativeLandingShell: the free
 * tools, the music video generator, the creative tools), and the homepage's
 * crawler HTML (server/_core/seo.ts).
 *
 * Oct 11 2026: no top-traffic page linked the ad page in its crawler HTML
 * (the homepage, the music video generator, the jingle and image generators,
 * the free audio tools). Each name is the ad page's own localized h1
 * (shared/creativeToolsSeoLocales; a test keeps them equal), copied here so
 * the homepage bundle does not pull in the creative-tools copy. Renderers add
 * the language prefix (/es/ai-video-ad-generator).
 */

export const AD_GENERATOR_PATH = "/ai-video-ad-generator";

export const AD_GENERATOR_LINK_LABELS = {
  en: "AI video ad generator",
  es: "Generador de anuncios en video con IA",
  ja: "AI動画広告メーカー",
  pt: "Gerador de anúncios em vídeo com IA",
  fr: "Générateur de pubs vidéo IA",
  zh: "AI 视频广告生成器",
  ko: "AI 영상 광고 생성기",
  id: "Pembuat iklan video AI",
  it: "Generatore di video pubblicitari AI",
  nl: "AI-videoadvertentie generator",
  pl: "Generator reklam wideo AI",
  tr: "Yapay zeka video reklam oluşturucu",
  vi: "Tạo video quảng cáo bằng AI",
  de: "KI-Werbevideo-Generator",
} as const;

export type AdGeneratorLinkLang = keyof typeof AD_GENERATOR_LINK_LABELS;

/** The ad generator's name in `lang`; English for a language Solmi doesn't serve. */
export function adGeneratorLinkLabel(lang: string): string {
  return (
    AD_GENERATOR_LINK_LABELS[lang as AdGeneratorLinkLang] ??
    AD_GENERATOR_LINK_LABELS.en
  );
}
